import { useContext, useState, useEffect } from 'react';
import { getUserIdFromJwt, getUserProfile } from '../api_helper/api';
import { identify } from '../utils/eventTracking';
import { UserProfileContext } from '../UserProfileContext';

// Optional Authentication HOC - populates user context if authenticated, but doesn't require it
const WithOptionalAuth = (WrappedComponent) => {
	return function WithOptionalAuthComponent(props) {
		const [userProfile, setUserProfile] = useContext(UserProfileContext);
		const [isLoading, setIsLoading] = useState(true);

		useEffect(() => {
			const checkAuthentication = async () => {
				// Check if JWT exists
				const jwt = localStorage.getItem('jwt');
				if (!jwt) {
					setIsLoading(false);
					return;
				}

				// Verify JWT and get user profile
				try {
					const user = await getUserIdFromJwt(jwt);
					if (user) {
						// Get full user profile
						const fullUserProfile = await getUserProfile();

						// Update the UserProfileContext
						setUserProfile(fullUserProfile);

						// Set user email for tracking
						identify(fullUserProfile.email);
					} else {
						// Invalid JWT, remove it
						localStorage.removeItem('jwt');
					}
				} catch (error) {
					// JWT verification failed, remove it
					localStorage.removeItem('jwt');
				}

				setIsLoading(false);
			};

			checkAuthentication();
		}, [setUserProfile]);

		// Show loading while checking authentication
		if (isLoading) {
			return <h1>Loading</h1>;
		}

		// Always render the wrapped component, regardless of authentication status
		return <WrappedComponent {...props} />;
	};
};

export default WithOptionalAuth;
